import { connect } from 'react-redux';
import { getFormValues, isValid, reset, submit } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import MainContentPending from '../pageStructure/mainContentPending/MainContentPending';
import CompanyDetails from './companyDetails/CompanyDetails';
import { SUBMIT_COMPANY_DETAILS } from './companyDetails/CompanyDetails.actions';
import PaymentDetails from './paymentDetails/PaymentDetails';
import People from './people/People';
import AccountDetails from './accountDetails/AccountDetails';
import { PromptSave } from './promptSave';
import { CANCEL_PROMPT, OPEN_PROMPT } from './Profile.actions';
import messages from './Profile.messages';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { trackPageView } from '../../tracking/pageView';
import { useEffect } from 'react';
import { useStateKey } from '../../iwQueryClient/useStateKey';
import { H1 } from '@ui';

const mapStateToProps = (state: RootState) => ({
    // @ts-expect-error
    ...state.profile,
    companyFormValues: getFormValues('CompanyDetails')(state),
    isCompanyFormValid: isValid('CompanyDetails')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    promptSave: () => dispatch({ type: OPEN_PROMPT }),
    cancelPrompt: () => dispatch({ type: CANCEL_PROMPT }),
    resetForm: () => dispatch(reset('CompanyDetails')),
    validateForm: () => dispatch(submit('CompanyDetails')),
    submitForm: (companyDetails: object) =>
        dispatch({ type: SUBMIT_COMPANY_DETAILS, companyDetails })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const Profile = ({
    resetForm,
    cancelPrompt,
    validateForm,
    submitForm,
    companyFormValues,
    isCompanyFormValid,
    ready,
    openPrompt,
    submitCompanyDetailsLoading,
    promptSave
}: PropsFromRedux) => {
    const stateKey = useStateKey();

    const handleCancelPrompt = () => {
        resetForm();
        setTimeout(() => {
            cancelPrompt();
        }, 0);
    };

    const submitPrompt = () => {
        validateForm();

        if (isCompanyFormValid) {
            submitForm(companyFormValues);
        }
    };

    useEffect(() => {
        if (ready) {
            trackPageView(stateKey, 'Profile');
        }
    }, [stateKey, ready]);

    if (!ready) return <MainContentPending data-testid="profile-loading" />;

    return (
        <div className="mx-auto max-w-5xl space-y-2xl px-s py-xl">
            <H1>
                <FormattedMessage {...messages.yourCompany} />
            </H1>

            <People />

            <PaymentDetails />

            {/* @ts-expect-error */}
            <CompanyDetails onChange={promptSave} />

            <AccountDetails />

            <PromptSave
                openPrompt={openPrompt}
                handleSubmitPrompt={submitPrompt}
                handleCancelPrompt={handleCancelPrompt}
                loading={submitCompanyDetailsLoading}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
